import { FitnessLevel } from './user';

export const COMPLEXITY_LEVELS_ARR = Object.values(FitnessLevel);
